<template>
    <div class="switch01 full-width row"
        :class="{
            'be-wide': isWide,
            'disabled': disabled,
        }"
    >
        <span class="one-tab"
            v-for="(curTab, idx) of aTabs" :key="idx"
            :class="{selected: ~~modelValue === idx}"
            @click="toSwitch(idx)"
        >
            <!-- ↓ 这里转了小写，另有css 控制其大小写将覆盖此操作 -->
            {{ $t(curTab.label).toLowerCase() }}
            <!-- ↓ 这是 🅘 图标，同时有弹出窗口的功能 -->
            <CasinoWidgetAutoTip 
                v-if="idx==1"
                :ref="el => tipIcon = el"
                :gameName="gameName"
            />
        </span>
    </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import useGlobalStore from '@/stores/global';
import oScssVar from '~/common/style/game.module.scss';
import useSettingsStore from '~/stores/settings';

const settingsStore = useSettingsStore(); 
const globalStore = useGlobalStore();
// const {t: $t} = useI18n(); 

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true,
    },
    beWideVal: { 
        type: Number, // 若收到数字500，表示屏幕宽度小于 500 时触发样式变化
        default: Number.parseInt(oScssVar.myWidthB),
    },
    disabled: Boolean,
    gameName: String,
});

const tipIcon = ref(null);
const emit = defineEmits(['update:modelValue']);

const isBlackJack = computed(() => { 
    const bResult = props.gameName === 'blackjackGame';
    return bResult;
});

const aTabs = computed(() => { 
    const aMode = [
        { label: `Manaual` },
        { label: `Auto` },
    ];
    if (isBlackJack.value){
        aMode[1].label = 'GameBlackJack.ProMode'; 
    }
    return aMode;
});


// 👇小屏幕模式
const isWide = computed(()=>{
    // 0表示永远不变为小屏模式
    if (props.beWideVal === 0){
        return false; 
    }
    return globalStore.innerWidth <= props.beWideVal;
});

function toSwitch(idx){
    // 👇 数字1表示自动模式
    const clickOnAutoMode = idx === 1; 
    emit('update:modelValue', idx === 1); 
    if (!clickOnAutoMode) return;
    // ↓ 如果切换到自动模式 && 用户未禁止窗口弹出 then 弹出窗口 
    if (isBlackJack.value){
        if (settingsStore.proModePopupDontShow === false){
            tipIcon.value.bReminderVisible = true;
        }
    }else if (settingsStore.autoPopupDontShow === false){
        tipIcon.value.bReminderVisible = true;
    }
}

</script>


<style scoped lang="scss">
// ▼手动自动切换器 01
.switch01{
    background: var(--color_background-90);
    border-bottom: 1px solid #1c2532;
    text-transform: capitalize;
    height: 48px;
    cursor: pointer;
    & > .one-tab{
        width: 50%;
        color: #93acd3;
        display: flex;
        justify-content: center;
        align-items: center;
        text-transform: capitalize;
        font-weight: 500;
        &:hover{
            color: white;
        }
    }
    &.be-wide{
        background: var(--color_grey-100);
    }
    &.disabled :deep(*){
        pointer-events: none;
    }
}

.one-tab.selected{
    overflow: hidden;
    position: relative;
    border-image-slice: 1;
    border-image-source: linear-gradient(to left, transparent 0, #ed1d49 50%, transparent 100%);
    border-style: solid;
    border-width: 2px;
    border-left: 0;
    border-right: 0;
    border-top: 0;
    color: white;
    &::before{
        content: "";
        background: #ed1d49;
        border-radius: 50%;
        display: block;
        filter: blur(12.5px);
        height: 30px;
        left: 50%;
        pointer-events: none;
        position: absolute;
        top: calc(100% - 5px);
        transform: translate(-50%);
        width: 80%;
    }
}


</style>
